export default getExperimentalFeatures;
function getExperimentalFeatures(experimentIsOpen: (key: string) => boolean) {
  return {
    newInfoElements: experimentIsOpen('se_proGalleryMasterInfo'),
    useImageAvifFormat: experimentIsOpen(
      'specs.thunderbolt.useImageAvifFormatInNativeProGallery',
    ),
  };
}
